import { render, staticRenderFns } from "./sopHazardFactorPop.vue?vue&type=template&id=144b70b4"
import script from "./sopHazardFactorPop.vue?vue&type=script&lang=js"
export * from "./sopHazardFactorPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('144b70b4')) {
      api.createRecord('144b70b4', component.options)
    } else {
      api.reload('144b70b4', component.options)
    }
    module.hot.accept("./sopHazardFactorPop.vue?vue&type=template&id=144b70b4", function () {
      api.rerender('144b70b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/pim/sopHazardFactorPop.vue"
export default component.exports